// extracted by mini-css-extract-plugin
export var noSpinners = "_oo-6";
export var percentageInput = "_oo-7";
export var variantColor1 = "_oo-0";
export var variantColor2 = "_oo-1";
export var variantColor3 = "_oo-2";
export var variantColor4 = "_oo-3";
export var variantColor5 = "_oo-4";
export var variantColor6 = "_oo-5";